import { FC } from "react";
import styles from "./Form.module.scss";
import FormHeadline from "./FormHeadline";
import FormItems from "./FormItems";
import Input from "@components/ui/input";
import FormItem from "./FormItem";
import FormSelect from "./FormSelect";
import Checkbox from "@components/ui/checkbox";
import FormButton from "./FormButton";
import { FieldValues, FormState, UseFormRegister, UseFormSetValue } from "react-hook-form";

interface Props {
    onSubmit?(): void;
    register: UseFormRegister<FieldValues>;
    setValue: UseFormSetValue<FieldValues>;
    formState: FormState<FieldValues>;
}

const Form: FC<Props> = ({ onSubmit, register, setValue, formState: { errors } }) => {
    const formCheckboxes = [
        { name: "exchange", label: "Token Exchange" },
        { name: "withdrawal", label: "Withdrawal" },
        { name: "purchase", label: "Purchase of NFT" },
        { name: "spam", label: "Spam transactions" },
    ];
    const setAll = () => {
        formCheckboxes.forEach(({ name }) => setValue(name, true));
    };

    return (
        <form onSubmit={onSubmit} className={styles.block}>
            <FormHeadline />
            <FormItems>
                <FormItem id="address" label="Adress whale">
                    <Input
                        error={errors.addressWhale}
                        register={register}
                        required
                        name="addressWhale"
                        placeholder="UQDmN...6JX8H"
                        id="address"
                        type="text"
                    />
                </FormItem>
                <FormItem id="whale" label="Name the whale">
                    <Input
                        error={errors.whale}
                        register={register}
                        required
                        name="whale"
                        placeholder="Mega whale"
                        id="whale"
                        type="text"
                    />
                </FormItem>
                <FormSelect setAll={setAll} />
                {formCheckboxes.map(({ label, name }) => (
                    <FormItem key={name} type="checkbox" id={name} label={label}>
                        <Checkbox register={register} name={name} id={name} />
                    </FormItem>
                ))}
                <FormButton />
            </FormItems>
        </form>
    );
};

export default Form;
